module.exports = __webpack_public_path__ + "img/home-icon-2.e7296ae7.png";